<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import axios from 'axios'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }else if("批量删除" == clickName){
          this.dataChanage("http://批量删除",{ids:this.deleteIds},res =>{
            if (res.data.code == 0){
            this.$message.success("suc");
            }else{

            }
          });
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage("http://新增或更新",model,res => {
          if (res.data.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                          { title: 'id', field: 'id'},
                          { title: '排行活动id（条件所属活动，lucky_redpacket_id id）', field: 'luckyRedPacketId'},
                          { title: '账号', field: 'account'},
                          { title: '用户名称', field: 'accountName'},
                          { title: '真实开户时间', field: 'openAccountTime'},
                          { title: '激活状态（1:已激活，2：未激活)', field: 'activationStatus'},
                          { title: '激活时间', field: 'activationTime'},
                          { title: '参与时间', field: 'participateInTime'},
                          { title: '红包金额', field: 'bonus'},
                          { title: '发放状态（1、待发奖 2、发放成功 3、发放失败）', field: 'status'},
                          { title: '领奖时间', field: 'receivePrizeTime'},
                          { title: '创建者', field: 'creator'},
                          { title: '创建时间', field: 'createDate'},
                          { title: '更新者', field: 'updater'},
                          { title: '更新时间', field: 'updateDate'},
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: 'id', field: 'id'},
                          { title: '排行活动id（条件所属活动，lucky_redpacket_id id）', field: 'luckyRedPacketId'},
                          { title: '账号', field: 'account'},
                          { title: '用户名称', field: 'accountName'},
                          { title: '真实开户时间', field: 'openAccountTime'},
                          { title: '激活状态（1:已激活，2：未激活)', field: 'activationStatus'},
                          { title: '激活时间', field: 'activationTime'},
                          { title: '参与时间', field: 'participateInTime'},
                          { title: '红包金额', field: 'bonus'},
                          { title: '发放状态（1、待发奖 2、发放成功 3、发放失败）', field: 'status'},
                          { title: '领奖时间', field: 'receivePrizeTime'},
                          { title: '创建者', field: 'creator'},
                          { title: '创建时间', field: 'createDate'},
                          { title: '更新者', field: 'updater'},
                          { title: '更新时间', field: 'updateDate'},
                          {click:"查询"},
              {click:"新增"},
              {click:"批量删除"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: "http://查询地址", //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: 'id', field: 'id'},
                          { title: '排行活动id（条件所属活动，lucky_redpacket_id id）', field: 'luckyRedPacketId'},
                          { title: '账号', field: 'account'},
                          { title: '用户名称', field: 'accountName'},
                          { title: '真实开户时间', field: 'openAccountTime'},
                          { title: '激活状态（1:已激活，2：未激活)', field: 'activationStatus'},
                          { title: '激活时间', field: 'activationTime'},
                          { title: '参与时间', field: 'participateInTime'},
                          { title: '红包金额', field: 'bonus'},
                          { title: '发放状态（1、待发奖 2、发放成功 3、发放失败）', field: 'status'},
                          { title: '领奖时间', field: 'receivePrizeTime'},
                          { title: '创建者', field: 'creator'},
                          { title: '创建时间', field: 'createDate'},
                          { title: '更新者', field: 'updater'},
                          { title: '更新时间', field: 'updateDate'},
                          {field:"修改",title:"操作",size:"mini",click:"update",type:"primary",icon:"el-icon-update"}
          ]
        }
      }
    }
  }
</script>
